import { getDB } from './db.js';

const KEY = 'lastPulledAt';

export async function getCursor(): Promise<string | null> {
  const db = await getDB();
  const v = await db.get('meta', KEY);
  return v ?? null;
}

export async function setCursor(isoTimestamp: string): Promise<void> {
  const db = await getDB();
  await db.put('meta', isoTimestamp, KEY);
}
